<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col sm>
        <b-card :title="$t('general.general')">
          <div class="col-sm-8 offset-sm-4">
            <div class="form-check">
              <input
                :id="`ride_types_${rideType}`"
                v-model="model.ride_types"
                :value="rideType"
                type="checkbox"
                class="form-check-input"
              />
              <label :for="`ride_types_${rideType}`">
                {{ $t('vehicles.is_available') }}
              </label>
            </div>
          </div>

          <fields ungrouped/>
        </b-card>

        <b-card v-if="rideType === 'delivery'" :title="$t('vehicles.field_groups.vehicle_attributes')">
          <fields :group="`attributes`"/>
        </b-card>
        <b-card v-else :title="$t('vehicles.field_groups.capacity')">
          <fields :group="`${rideType}_capacity`"/>
        </b-card>

        <b-card v-if="false" :title="$t('vehicles.field_groups.additional')">
          <fields :group="`${fieldsGroupPrefix}additional`"/>
        </b-card>
      </b-col>
      <b-col sm>
        <b-card :title="$t('vehicles.field_groups.standard')">
          <fields :group="`${fieldsGroupPrefix}standard`"/>
        </b-card>
        <b-card v-if="model.pricing && false" :title="$t('vehicles.field_groups.day_night')">
          <fields :group="`${fieldsGroupPrefix}day_night`" @input="onChangeDayNightFieldsComponentType"/>
          <div class="form-row mt-1">
            <div class="col-4">&nbsp;</div>
            <div class="form-group col-4">{{ $t('general.day') }}</div>
            <div class="form-group col-4">{{ $t('general.night') }}</div>
          </div>
          <div v-for="(day, i) in days" :key="day" class="form-row">
            <div class="col-4 text-right pt-1">
              {{
                $moment()
                  .day(i + 1)
                  .format('dddd')
              }}
            </div>
            <div class="form-group col-4">
              <field
                :name="`${fieldsGroupPrefix}pricing.days.${day}.day`"
                layout="empty"
              />
            </div>
            <div class="form-group col-4">
              <field
                :name="`${fieldsGroupPrefix}pricing.days.${day}.night`"
                layout="empty"
              />
            </div>
          </div>
        </b-card>

        <b-card v-if="id && false">
          <b-button
            v-if="rideType === 'transfer'"
            v-b-modal="'zone-pricing-dialog'"
            class="mr-2 zone-pricing"
          >
            {{ $t('vehicles.field_groups.zone_pricing') }}
          </b-button>
          <b-button
            v-if="rideType === 'transfer'"
            v-b-modal="'airport-rates-dialog'"
            class="mr-2 airport-rates"
          >
            {{ $t('vehicles.field_groups.airport-rates') }}
          </b-button>
          <b-button
            class="mr-2"
            @click="$bvModal.show('zone-to-zone-pricing-dialog')"
          >
            {{ $t('vehicles.zone_to_zone_pricing') }}
          </b-button>
          <zone-pricing :vehicle-id="id"/>
          <airport-rate :vehicle-id="id"/>
        </b-card>
      </b-col>
    </b-row>
    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import {ResourceFormMixin} from 'stylemix-vue-admin'
import VehiclesApi from './Api'
import ZonePricing from './zone-pricing/ZonePricing'
import AirportRate from './airport-rates/AirportRate'

export default {
  name: 'VehicleForm',

  components: {
    AirportRate,
    ZonePricing,
  },

  mixins: [ResourceFormMixin],
  props: {
    rideType: {
      type: String,
      default: 'transfer',
    },
  },

  data() {
    return {
      base: 'vehicles',
      formLoaded: false,
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
      periods: [
        'day',
        'night',
      ],
    }
  },

  computed: {
    fieldsGroupPrefix() {
      if (this.rideType === 'transfer') {
        return ''
      }

      return this.rideType + '_'
    },
  },

  watch: {
    currentDivision: {
      handler(newVal) {
        if (newVal && !this.formLoaded) {
          this.formLoaded = true
          this.loadForm().then(() => {
            this.setFieldGroup('standard', [
              'pricing.by_request',
              'pricing.by_request_percent',
              'pricing.one_way',
              'pricing.per_minute',
              'pricing.price_per_km',
              'pricing.return',
              'pricing.return_price_per_km',
              'pricing.return_discount',
              'pricing.standing_fee',
              'pricing.minimum_price',
              'pricing.prepayment_oncash',
              'pricing.prepayment_percent_oncash',
            ])
            this.setFieldGroup('additional', [
              'pricing.base_discount',
              'pricing.meet_greet',
              'pricing.disabled_place',
              'pricing.baby_seat',
              'pricing.booster_seat',
              'pricing.child_seat',
              'pricing.bike',
              'pricing.ski_equipment_fee',
              'pricing.passenger_fee_min',
              'pricing.passenger_fee',
              'pricing.animal_fee',
              'pricing.waiting_time_per_minute',
            ])

            this.setFieldGroup('day_night', [
              'pricing.night_threshold.start',
              'pricing.night_threshold.end',
              'pricing.days_metric',
            ])

            this.setFieldGroup('city_taxi_standard', [
              'city_taxi_pricing.by_request',
              'city_taxi_pricing.by_request_percent',
              'city_taxi_pricing.one_way',
              'city_taxi_pricing.per_minute',
              'city_taxi_pricing.price_per_km',
              'city_taxi_pricing.return',
              'city_taxi_pricing.return_price_per_km',
              'city_taxi_pricing.return_discount',
              'city_taxi_pricing.standing_fee',
              'city_taxi_pricing.minimum_price',
              'city_taxi_pricing.prepayment_oncash',
              'city_taxi_pricing.prepayment_percent_oncash',
              'city_taxi_pricing.base_discount',
            ])
            this.setFieldGroup('city_taxi_additional', [
              'city_taxi_pricing.meet_greet',
              'city_taxi_pricing.disabled_place',
              'city_taxi_pricing.baby_seat',
              'city_taxi_pricing.booster_seat',
              'city_taxi_pricing.child_seat',
              'city_taxi_pricing.bike',
              'city_taxi_pricing.ski_equipment_fee',
              'city_taxi_pricing.passenger_fee_min',
              'city_taxi_pricing.passenger_fee',
              'city_taxi_pricing.animal_fee',
              'city_taxi_pricing.waiting_time_per_minute',
            ])

            this.setFieldGroup('city_taxi_day_night', [
              'city_taxi_pricing.night_threshold.start',
              'city_taxi_pricing.night_threshold.end',
              'city_taxi_pricing.days_metric',
            ])

            this.setFieldGroup('delivery_standard', [
              'delivery_pricing.by_request',
              'delivery_pricing.by_request_percent',
              'delivery_pricing.one_way',
              'delivery_pricing.price_per_km',
              'delivery_pricing.standing_fee',
              'delivery_pricing.minimum_price',
              'delivery_pricing.prepayment_oncash',
              'delivery_pricing.prepayment_percent_oncash',
            ])
            this.setFieldGroup('delivery_additional', [
              'delivery_pricing.base_discount',
              'delivery_pricing.door_to_door',
              'delivery_pricing.loaders',
              'delivery_pricing.waiting_time_per_minute',
            ])

            this.setFieldGroup('delivery_day_night', [
              'delivery_pricing.night_threshold.start',
              'delivery_pricing.night_threshold.end',
              'delivery_pricing.days_metric',
            ])

            this.setFieldGroup('ride_types', ['ride_types'])

            this.$set(this.model, 'ride_types', this.model.ride_types || [])
            if (!this.model.ride_types.includes(this.rideType)) {
              this.model.ride_types.push(this.rideType)
            }

            this.setFieldGroup('attributes', [
              'attributes.width',
              'attributes.height',
              'attributes.length',
              'attributes.lifting_weight',
              'attributes.pallets',
            ])

            if (!this.model.pricing) {
              this.model.pricing = {}
            }

            if (!this.model.city_taxi_pricing) {
              this.model.city_taxi_pricing = {}
            }
            if (!this.model.delivery_pricing) {
              this.model.delivery_pricing = {}
            }

            if (!this.model.pricing.night_threshold) {
              this.model.pricing.night_threshold = {}
            }
            if (!this.model.city_taxi_pricing.night_threshold) {
              this.model.city_taxi_pricing.night_threshold = {}
            }
            if (!this.model.delivery_pricing.night_threshold) {
              this.model.delivery_pricing.night_threshold = {}
            }

            // set day/night fields component types initially
            this.setDayNightFieldsComponentType('pricing', this.model.pricing.days_metric)
            this.setDayNightFieldsComponentType('city_taxi_pricing', this.model.city_taxi_pricing.days_metric)
            this.setDayNightFieldsComponentType('delivery_pricing', this.model.delivery_pricing.days_metric)
          })
        }
      },
      immediate: true,
    },
  },

  methods: {
    api() {
      return new VehiclesApi().setParameters({
        division_id: this.currentDivision.id,
      })
    },

    submit() {
      if(!this.model.ride_types.length) {
        this.model.ride_types.push('city_taxi');
      }
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },

    setDayNightFieldsComponentType(rideType, selectedDaysMetric) {
      // filter day_night pricing fields
      let dayNightPricingAttrs = this.fields.list.filter(field =>
        this.days.some(day =>
          this.periods.some(period => field.attribute === rideType + `.days.${day}.${period}`)
        )
      );

      // change dayNightPricingAttrs component type`s based on pricing.days_metric`s select field
      if (selectedDaysMetric === 'fixed' || selectedDaysMetric === 'surcharge') {
        dayNightPricingAttrs.map(field => field.component = 'price-in-selected-currency-field')
      } else {
        dayNightPricingAttrs.map(field => field.component = 'number-field')
      }
    },

    onChangeDayNightFieldsComponentType(fieldData) {
      this.setDayNightFieldsComponentType(this.fieldsGroupPrefix + 'pricing', fieldData.value)
    },

  },
}
</script>
